module.exports = __webpack_public_path__ + "static/media/tc_logo_orange.5775f286.png";